import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
	inputClass: {
		fontSize: '14px'
	}
});

@withStyles(styles)
class FormField extends Component {
	render() {
		const { classes, maxLength, autosize, inputProps, ...passProps} = this.props;
		delete passProps.classes;
		const dataTid = passProps['data-tid'];

		return (<TextField
			{...passProps}
			{...(autosize ? { multiline: true, rowsMax: 2 } : {})}
			InputProps={{
				...inputProps,
				'data-tid': dataTid ? `input-${dataTid}` : undefined,
				disableUnderline: true,
				spellCheck: 'false'
			}}
			inputProps={{
				maxLength: maxLength,
			}}			
		/>);
	}
}

FormField.propTypes = {
	classes: PropTypes.object,
	maxLength: PropTypes.number,
	autosize: PropTypes.bool,
	inputProps: PropTypes.object,
};

export default FormField;



// WEBPACK FOOTER //
// ./src/components/FormField/index.js